import { Link } from "react-router-dom";

const IMG = "https://images.unsplash.com/photo-1524495918456-131d6fca8b5f?crop=entropy&cs=srgb&fm=jpg&w=1400&q=80";

export default function About() {
  return (
    <div>
      <section className="relative h-[42vh] min-h-[280px] overflow-hidden bg-[#1E3A2F]">
        <img src={IMG} alt="" className="w-full h-full object-cover opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1E3A2F] to-transparent" />
        <div className="absolute inset-x-0 bottom-0 max-w-5xl mx-auto px-5 sm:px-8 pb-10 text-[#F7F4EB]">
          <div className="text-xs uppercase tracking-[0.2em] text-[#DDA74A] font-semibold">About us</div>
          <h1 className="font-display text-4xl sm:text-6xl mt-2 leading-tight">A bridge between home<br /> and the Pacific Northwest.</h1>
        </div>
      </section>

      <section className="max-w-4xl mx-auto px-5 sm:px-8 py-14 space-y-6 text-[#1A1A1A] leading-relaxed">
        <p>African Bridge Media is a community-run marketplace and events hub built for the African diaspora across Washington State. We connect neighbors from Seattle to Spokane, from Renton to Redmond — the choir directors, the entrepreneurs, the mothers with baby clothes to pass on, the students, the elders.</p>
        <p>Buy and sell locally. Give what you no longer need. Announce your church revival, your independence day cookout, or the graduation party you want everyone to know about. When our community is easy to find, showing up gets a whole lot easier.</p>

        <div className="grid sm:grid-cols-3 gap-4 pt-4">
          {["Ubuntu · we are because we are","Local first · Washington-focused","Community-owned"].map((t) => (
            <div key={t} className="rounded-2xl bg-white border border-[#E2DED0] p-5 font-display text-[#1E3A2F]">{t}</div>
          ))}
        </div>

        <div className="pt-6">
          <Link to="/signup" className="rounded-full abm-btn-primary px-6 h-11 leading-[2.75rem] text-white inline-block">Join the community</Link>
        </div>
      </section>
    </div>
  );
}
